export enum ThemeEnum {
  DARK = 'dark',
  LIGHT = 'light',
}
